module.exports = __webpack_public_path__ + "static/media/Galleria - DK Chocolate_Orange.3ba2ae57.jpg";